define([
    "jquery",
    "underscore",
    "marionette",
    "forms/card/request_form",
    "behaviors/form_errors_behavior",
    "signature_pad",
    "jquery.fileupload",
    "backbone.syphon",
    "holdon"
], function($, _, Marionette, RequestForm, FormErrorsBehavior, SignaturePad) {
    return Marionette.View.extend({
        el: '#content_layout',

        ui:{
            'submitBtn': '.ct_btn8',
            'form': '#request_form',
            'signaturePad': '#signature_pad',
            'signatureImg': '#signature_img',
            'clearSignature': '#clear_signature',
            'poaFile': '#poa_file',
            'poaName': '#poa_name',
            'poa': '#poa',
            'pleFile': '#ple_file',
            'pleName': '#ple_name',
            'ple': '#ple',
            'identificationFile': '#identification_file',
            'identificationName': '#identification_name',
            'identification': '#identification'
        },

        events:{
            'click @ui.submitBtn': 'submit',
            'click @ui.clearSignature': function(e){
                if(e) e.preventDefault();

                this.signaturePad.clear();
            }
        },

        behaviors: {
            formErrors: {
                behaviorClass: FormErrorsBehavior
            }
        },

        initialize: function(){
            this.bindUIElements();

            this.form = new RequestForm();

            // Trick to give the canvas the sizes defined in CSS.
            // We need to access the real canvas and not the jquery wrapper.
            this.ui.signaturePad[0].width = this.ui.signaturePad[0].offsetWidth;
            this.ui.signaturePad[0].height  = this.ui.signaturePad[0].offsetHeight;

            this.signaturePad = new SignaturePad(this.ui.signaturePad[0]);

            this.initFileUpload(this.ui.pleFile, 'ple');
            this.initFileUpload(this.ui.identificationFile, 'identification');
            this.initFileUpload(this.ui.poaFile, 'poa');
        },

        initFileUpload: function($selector, type){
            var that = this;
            $selector.fileupload({
                url: '/rest_card/'+that.toUnderscore(type),
                dataType: 'json',
                // File selected, put the original name in the textbox
                add: function(e, data){
                    HoldOn.open({
                        theme:"sk-fading-circle"
                    });
                    data.submit();
                },
                // Upload success, put the server-side name in the hidden input
                done: function(e, data){
                    that.ui[type+'Name'].val(data.files[0].name);
                    that.ui[type].val(data.jqXHR.responseJSON.file_path);

                    HoldOn.close();
                },
                // Upload failed, display error + remove name from textbox
                fail: function(e,data){
                    var errors = {};
                    // CamelCase to under_score
                    errors[that.toUnderscore(type)] = data.jqXHR.responseJSON.error_msg;

                    that.ui[type+'Name'].val('');
                    that.ui[type].val('');

                    HoldOn.close();

                    that.triggerMethod('show:errors', errors);
                }
            });
        },

        toUnderscore: function(string){
            return string.replace(/([A-Z])/g, function($1){return "_"+$1.toLowerCase();});
        },

        submit: function(e){
            var that = this;
            if(e) e.preventDefault();

            if(!this.signaturePad.isEmpty()){
                this.ui.signatureImg.val(this.signaturePad.toDataURL());
            }
            var formData = Backbone.Syphon.serialize(this);
            this.form.set(formData);

            var errors = this.form.validate();

            if(_.size(errors) < 1){
                this.form.validateWithServer({
                    type: 'POST',
                    success: function(model, res){
                        that.ui.form.submit();
                    },
                    error: function(model, error){
                        that.triggerMethod('show:errors', error.responseJSON);
                    }
                });
            }else{
                this.triggerMethod('show:errors', errors);
            }
        }
    });
});